<script setup lang="ts">
import { TextButtonProps } from './types'

defineProps({
  buttonText: null,
  onButtonClick: { type: Function }
})
</script>

<template>
  <q-btn
    flat
    no-caps
    unelevated
    color="primary-blue"
    :label="buttonText"
    class="text-button"
    @click="onButtonClick"
  />
</template>

<style lang="scss">
body.desktop {
  .text-button {
    &.q-focusable:focus > .q-focus-helper,
    &.q-hoverable:hover > .q-focus-helper {
      opacity: 0;
    }
  }
}
</style>

<style lang="scss" scoped>
@import '~vars';
@import '~utilities';

.text-button {
  @extend .button-medium;
  padding: 12px 28px;

  /* tertiary button styles */
  &.q-btn--flat {
    &.text-primary-blue {
      &:hover {
        color: $secondary-azur-60 !important;
      }

      &:active {
        color: $secondary-azur-90 !important;
      }

      &[disabled],
      &.disabled {
        color: #8080CC !important;
      }
    }
  }
}
</style>
